import { useId as useReactId } from "react";

export const useId = (id?: string) => {
  const reactId = useReactId();

  return id ?? reactId;
};
